import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { adminApi } from "@/lib/api";
import { ChartPieSlice, Pulse, BookmarkSimple, Gear, Scan, Camera, Receipt, Warning, UsersThree } from "@phosphor-icons/react";

export const NAV_ITEMS = [
  { to: "/", label: "OPPORTUNITIES", icon: ChartPieSlice, id: "nav-dashboard" },
  { to: "/scans", label: "SCAN ENGINE", icon: Scan, id: "nav-scans" },
  { to: "/watchlists", label: "WATCHLISTS", icon: BookmarkSimple, id: "nav-watchlists" },
  { to: "/invoices", label: "INVOICES", icon: Receipt, id: "nav-invoices" },
  { to: "/identify", label: "IDENTIFY", icon: Camera, id: "nav-identify" },
  { to: "/anomalies", label: "ANOMALIES", icon: Warning, id: "nav-anomalies" },
  { to: "/site-users", label: "SITE USERS", icon: UsersThree, id: "nav-site-users" },
  { to: "/settings", label: "SETTINGS", icon: Gear, id: "nav-settings" },
];

/** Apply the owner's saved order/hidden flags; Settings always stays reachable. */
export function applyLayout(layout) {
  const byId = Object.fromEntries(NAV_ITEMS.map(i => [i.id, i]));
  const ordered = (layout || []).map(l => byId[l.id] && { ...byId[l.id], hidden: !!l.hidden && l.id !== "nav-settings" }).filter(Boolean);
  const missing = NAV_ITEMS.filter(i => !ordered.some(o => o.id === i.id)).map(i => ({ ...i, hidden: false }));
  return [...ordered, ...missing];
}

export default function Sidebar() {
  const [items, setItems] = useState(NAV_ITEMS);
  useEffect(() => {
    const load = () => adminApi.uiLayout().then(d => setItems(applyLayout(d.nav).filter(i => !i.hidden))).catch(() => {});
    load();
    window.addEventListener("nav-layout-changed", load);
    return () => window.removeEventListener("nav-layout-changed", load);
  }, []);
  return (
    <aside className="hidden md:flex flex-col w-52 border-r border-[#E4E4E0] bg-[#FFFFFF] py-4" data-testid="sidebar">
      <div className="px-3 mb-4 font-mono text-[10px] uppercase tracking-[0.18em] text-gray-400">NAVIGATION</div>
      <nav className="flex flex-col gap-1 px-2">
        {items.map((i) => (
          <NavLink
            key={i.to}
            to={i.to}
            end={i.to === "/"}
            data-testid={i.id}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-sm font-mono text-[11px] uppercase tracking-wider transition-colors ${
                isActive
                  ? "bg-[#E3000B]/10 text-[#E3000B] border-l-2 border-[#E3000B]"
                  : "text-gray-600 hover:text-black hover:bg-[#F6F6F3]"
              }`
            }
          >
            <i.icon size={16} weight="bold" />
            {i.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto px-3">
        <div className="border border-[#E4E4E0] p-3 rounded-sm bg-[#F6F6F3]">
          <div className="flex items-center gap-2 mb-1">
            <Pulse size={12} weight="fill" className="text-[#00A850] animate-pulse" />
            <span className="font-mono text-[10px] uppercase text-gray-500">Status</span>
          </div>
          <div className="font-mono text-[11px] text-[#00A850]">ENGINE ONLINE</div>
          <div className="font-mono text-[10px] text-gray-400 mt-1">Keepa · BrickLink</div>
        </div>
      </div>
    </aside>
  );
}
